import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { LanguageGate } from './components/LanguageGate';
import { Landing } from './pages/Landing';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3ka4bd2zaadjv">
      <LanguageGate data-id="element-1" data-mp="3k8jeh6phyiiu">
        <Landing data-id="element-2" data-mp="3k8t8r6hkrbuc" />
      </LanguageGate>
    </LanguageProvider>;
}